import { getBseUrl } from '@/constants';
import { request } from '@umijs/max';
let BASEURL = getBseUrl();

//导航栏接口
export async function listByType(params, options) {
  return request(`${BASEURL}/con/category/listByType`, {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
//页面接口
export async function listPage(params, options) {
  return request(`${BASEURL}/con/showModule/listPage`, {
    method: 'POST',
    data: params,
    ...(options || {}),
  });
}

//页脚接口
export async function queryBySiteId(params, options) {
  return request(`${BASEURL}/sys/siteFooter/queryBySiteId`, {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
